
<template>
  <div class="retail-hotel-filter">
    <h1 class="top-text">
      WHERE WILL YOUR ROOMCASH TAKE YOU?
    </h1>
    <h3 class="secondary-top-text">
      START YOUR SEARCH AND CHOOSE FROM 600,000+ GLOBAL HOTELS
    </h3>
    <div class="roomcash-search-container container">
      <div class="hotel-search-params">
        <div class="hotel-search-form-container">
          <div
            class="hotel-search-form"
          >
            <!-- Destination search box -->
            <div class="destination">
              <label
                for="hotel_search_destination"
                class="hotel-search-destination"
              >
                City Search:
                <i
                  class="fa fa-times"
                  @click="exitSearchForm($event)"
                />
              </label>
              <i class="fa fa-map-marker" />
              <Field
                id="roomcash_hotel_search_destination"
                v-model="destination"
                rules="required"
                class="form-control roomcash_hotel_search_destination"
                type="text"
                :placeholder="$t(&quot;h4h.destinationPlaceholder&quot;)"
                name="destination"
                @blur="validateField(destination, errorblocks[0])"
              />
              <label
                id="hotel_form_search_error"
                class="hotel_form_search_error"
                for="hotel_search_destination"
              />
            </div>
          </div>
        </div>
        <div class="stay-dates">
          <label
            for="hotel_search_datepicker"
            class="date_label"
          >
            {{ $t('h4h.checkIn') }} - {{ $t('h4h.checkOut') }}
          </label>
          <!-- eslint-disable -->
        <DatePicker 
          id="hotel_search_datepicker"
          v-model:value="selectedDates"
          :disabled-date="notBeforeToday"
          name="dates" 
          placeholder="Select date range" 
          range
        />
        <!-- eslint-enable -->
          <label
            id="hotel_form_search_dates_error"
            as="label"
            name="dates"
            class="dates_error error help is-danger is-italic"
          />
        </div>
        <div class="rooms-adults-container">
          <div class="mobile-hotel-date-holder">
            <div class="room-quantity-parent">
              <div class="room-quantity">
                <label class="room-quantity-label">
                  {{ $t('h4h.roomNum') }}
                </label>
                <div class="counter">
                  <span
                    :class="[disableRoomSubtraction ? 'disable' : '', 'subtract']"
                    @click="updateRoomQuantity(-1, 'subtract')"
                  />
                  <span class="number-of-rooms">
                    {{ roomQuantity }}
                  </span>
                  <span
                    :class="[disableRoomAddition ? 'disable' : '', 'add']"
                    @click="updateRoomQuantity(1, 'add')"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="mobile-hotel-date-holder">
            <div class="room-quantity-parent">
              <div class="room-quantity">
                <label>
                  # of Adults
                </label>
                <div class="counter">
                  <span
                    :class="[disableAdultSubtraction ? 'disable' : '', 'subtract']"
                    @click="updateAdultQuantity(-1, 'subtract')"
                  />
                  <span class="number-of-rooms">
                    {{ adultQuantity }}
                  </span>
                  <span
                    :class="[disableAdultAddition ? 'disable' : '', 'add']"
                    @click="updateAdultQuantity(1, 'add')"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="roomcash-filter-by-section-container">
        <div class="amenities-filter-container">
          <p class="section-subtitle">
            Amenities:
          </p>
          <label
            for="airportShuttle"
            class="filter-option"
          >
            <input
              id="airportShuttle"
              v-model="hotel.propertyAmenities"
              class="filter-sort-field roomcash-amenity"
              type="checkbox"
              name="Shuttle"
              value="reqAirportShuttle"
            >
            <div
              class="fa fa-check-container"
              @click="displayCheckmark"
            >
              <i class="fa fa-check roomcash-hotel-filter" />
            </div>
            {{ $t("h4h.airportShuttle") }}
          </label>
          <br>
          <label
            for="breakfast"
            class="filter-option"
          >
            <input
              id="breakfast"
              v-model="hotel.propertyAmenities"
              class="filter-sort-field roomcash-amenity"
              type="checkbox"
              name="Breakfast"
              value="reqBreakfast"
            >
            <div
              class="fa fa-check-container"
              @click="displayCheckmark"
            >
              <i class="fa fa-check roomcash-hotel-filter" />
            </div>
            {{ $t("h4h.breakfast") }}
          </label>
          <br>
          <label
            for="kitchenKitchenette"
            class="filter-option"
          >
            <input
              id="kitchenKitchenette"
              v-model="hotel.propertyAmenities"
              class="filter-sort-field roomcash-amenity"
              type="checkbox"
              name="Kitchen/Kitchenette"
              value="reqKitchenKitchenette"
            >
            <div
              class="fa fa-check-container"
              @click="displayCheckmark"
            >
              <i class="fa fa-check roomcash-hotel-filter" />
            </div>
            Kitchen/Kitchenette
          </label>
          <br>
          <label
            for="fitnessCenter"
            class="filter-option"
          >
            <input
              id="fitnessCenter"
              v-model="hotel.propertyAmenities"
              class="filter-sort-field roomcash-amenity"
              type="checkbox"
              name="FitnessCenter"
              value="reqFitnessCenter"
            >
            <div
              class="fa fa-check-container"
              @click="displayCheckmark"
            >
              <i class="fa fa-check roomcash-hotel-filter" />
            </div>
            {{ $t("h4h.fitness") }}
          </label>
          <br>
          <label
            for="internet"
            class="filter-option"
          >
            <input
              id="internet"
              v-model="hotel.propertyAmenities"
              class="filter-sort-field roomcash-amenity"
              type="checkbox"
              name="Internet"
              value="reqInternet"
            >
            <div
              class="fa fa-check-container"
              @click="displayCheckmark"
            >
              <i class="fa fa-check roomcash-hotel-filter" />
            </div>
            {{ $t("h4h.internet") }}</label>
          <br>
          <label
            for="pets"
            class="filter-option"
          >
            <input
              id="pets"
              v-model="hotel.propertyAmenities"
              class="filter-sort-field roomcash-amenity"
              type="checkbox"
              value="reqPets"
            >
            <div
              class="fa fa-check-container"
              @click="displayCheckmark"
            >
              <i class="fa fa-check roomcash-hotel-filter" />
            </div>
            {{ $t("h4h.pets") }}
          </label>
          <br>
          <label
            for="pool"
            class="filter-option"
          >
            <input
              id="pool"
              v-model="hotel.propertyAmenities"
              class="filter-sort-field roomcash-amenity"
              type="checkbox"
              name="Pool"
              value="reqPool"
            >
            <div
              class="fa fa-check-container"
              @click="displayCheckmark"
            >
              <i class="fa fa-check roomcash-hotel-filter" />
            </div>
            {{ $t("h4h.pool") }}
          </label>
          <br>
          <label
            for="restaurant"
            class="filter-option"
          >
            <input
              id="restaurant"
              v-model="hotel.propertyAmenities"
              class="filter-sort-field roomcash-amenity"
              type="checkbox"
              name="Restaurant"
              value="reqRestaurant"
            >
            <div
              class="fa fa-check-container"
              @click="displayCheckmark"
            >
              <i class="fa fa-check roomcash-hotel-filter" />
            </div>
            {{ $t("h4h.restaurant") }}
          </label>
        </div>
        <div class="property-filter-container">
          <p class="section-subtitle">
            Property Type:
          </p>
          <label
            for="resort"
            class="filter-option"
          >
            <input
              id="resort"
              v-model="hotel.propertyTypes"
              class="filter-sort-field roomcash-amenity"
              type="checkbox"
              name="Resort"
              value="6"
            >
            <div
              class="fa fa-check-container"
              @click="displayCheckmark"
            >
              <i class="fa fa-check roomcash-hotel-filter" />
            </div>
            Resort
          </label>
          <br>
          <label
            for="hotel"
            class="filter-option"
          >
            <input
              id="hotel"
              v-model="hotel.propertyTypes"
              class="filter-sort-field roomcash-amenity"
              type="checkbox"
              name="Hotel"
              value="1"
            >
            <div
              class="fa fa-check-container"
              @click="displayCheckmark"
            >
              <i class="fa fa-check roomcash-hotel-filter" />
            </div>
            Hotel
          </label>
          <br>
          <label
            for="extendedStay"
            class="filter-option"
          >
            <input
              id="extendedStay"
              v-model="hotel.propertyTypes"
              class="filter-sort-field roomcash-amenity"
              type="checkbox"
              name="Extended Stay"
              value="8"
            >
            <div
              class="fa fa-check-container"
              @click="displayCheckmark"
            >
              <i class="fa fa-check roomcash-hotel-filter" />
            </div>
            Extended Stay
          </label>
          <br>
          <label
            for="bedBreakfast"
            class="filter-option"
          >
            <input
              id="bedBreakfast"
              v-model="hotel.propertyTypes"
              class="filter-sort-field roomcash-amenity"
              type="checkbox"
              name="Bed/Breakfast"
              value="9"
            >
            <div
              class="fa fa-check-container"
              @click="displayCheckmark"
            >
              <i class="fa fa-check roomcash-hotel-filter" />
            </div>
            B&B
          </label>
          <br>
          <label
            for="motel"
            class="filter-option"
          >
            <input
              id="motel"
              v-model="hotel.propertyTypes"
              class="filter-sort-field roomcash-amenity"
              type="checkbox"
              name="Motel"
              value="5"
            >
            <div
              class="fa fa-check-container"
              @click="displayCheckmark"
            >
              <i class="fa fa-check roomcash-hotel-filter" />
            </div>
            Motel
          </label>
          <br>
          <label
            for="vacationRental"
            class="filter-option"
          >
            <input
              id="vacationRental"
              v-model="hotel.propertyTypes"
              class="filter-sort-field roomcash-amenity"
              type="checkbox"
              value="12"
            >
            <div
              class="fa fa-check-container"
              @click="displayCheckmark"
            >
              <i class="fa fa-check roomcash-hotel-filter" />
            </div>
            Vacation Rental
          </label>
        </div>
        <div class="search-button-container">
          <button
            class="search-button"
            @click="searchHotels"
          >
            SEARCH
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* global google */
import DatePicker from 'vue-datepicker-next'
import moment from 'moment'
import { mapState, mapMutations, mapActions } from 'vuex'
import mixin from './add_to_cart_forms/h4h_hotels/hotel_availability.vue'
import { Field } from 'vee-validate'

export default {
  components: {
    DatePicker,
    Field
  },
  mixins: [mixin],
  data() {
    return {
      roomQuantity: 1,
      adultQuantity: 1,
      destination: null,
      latitude: null,
      longitude: null,
      selectedDates: [],
      errorblocks: [
        'hotel_form_search_error',
        'hotel_form_search_checkin_error',
        'hotel_form_search_checkout_error'
      ]
    }
  },
  computed: {
    ...mapState({
      hotel: state => state.hotel
    }),
    order(){
      return this.$store.state.order.order
    },
  },

  created(){
    this.hotel.checkInDate = moment(this.placeholderCheckIn(0))._d
    this.hotel.checkOutDate = moment(this.placeholderCheckIn(3))._d
  },

  async mounted() {
    this.latitude = this.hotel.h4hLatitude || this.hotel.searchLatitude
    this.longitude = this.hotel.h4hLongitude || this.hotel.searchLongitude
    if(!this.destination) {
      await this.getBackendOrder()
      this.enableAutocomplete()
    }
  },

  methods: {
    ...mapMutations(['hotel']),
    ...mapActions('order', ['getBackendOrder']),

    updateRoomQuantity(value, operation) {
      switch(operation) {
      case 'add':
        if (this.roomQuantity < 10) {
          this.roomQuantity += 1
        }
        break

      case 'subtract':
        if (this.roomQuantity > 1) {
          this.roomQuantity -= 1
        }
        break
      }
    },

    displayCheckmark() {
      if(event.target.style.opacity === '' || event.target.style.opacity === '0') {
        event.target.style.opacity = '1'
      } else {
        event.target.style.opacity = '0'
      }
    },

    updateAdultQuantity(value, operation) {
      switch(operation) {
      case 'add':
        if (this.adultQuantity < 10) {
          this.adultQuantity += 1
        }
        break

      case 'subtract':
        if (this.adultQuantity > 1) {
          this.adultQuantity -= 1
        }
        break
      }
    },

    enableAutocomplete() {
      let input = document.getElementById('roomcash_hotel_search_destination')
      let autocomplete = new google.maps.places.Autocomplete(input)

      autocomplete.setFields(['address_components', 'geometry', 'icon', 'name'])


      google.maps.event.addDomListener(input, 'keydown', event => {
        let dropdown = document.getElementsByClassName('pac-container')[0]
        if (event.keyCode === 13 && dropdown.style.display !== 'none') {
          event.preventDefault()
        }
      })

      autocomplete.addListener('place_changed', () => {

        let place = autocomplete.getPlace()
        this.destination = input.value
        this.latitude = place.geometry.location.lat()
        this.longitude = place.geometry.location.lng()
      })
    },

    placeholderCheckIn(amount) {
      var date = new Date()
      date.setDate(date.getDate() + amount)
      var newDate = date.toISOString().split('T')[0]
      return newDate
    },

    notBeforeToday(date) {
      return date < moment().subtract(1, 'days')
    },

    reformatDate(date){
      return moment(date).format('YYYY-MM-DD')
    },

    validateField(elem, errorblockelem) {
      let errorblock = document.getElementById(errorblockelem)
      if(elem) {
        errorblock.style.display = 'none'
      } else {
        errorblock.innerHTML = 'This field is required'
        errorblock.style.display = 'block'
      }
    },

    async searchHotels(e) {
      if(this.destination && this.selectedDates) {
        this.hotel.destination = document.getElementById('roomcash_hotel_search_destination').value

        if (document.getElementsByClassName('event')[0]) {
          let event_id = document.getElementsByClassName('event')[0].dataset.eventId
          window.location.href=`/cart/events/${event_id}/hotels?destination=${this.hotel.destination}&checkInDate=${this.reformatDate(this.selectedDates[0])}&checkOutDate=${this.reformatDate(this.selectedDates[1])}&adults=${this.adultQuantity}&rooms=${this.roomQuantity}&latitude=${this.latitude}&longitude=${this.longitude}&propertyClasses=${this.hotel.propertyClasses}&propertyTypes=${this.hotel.propertyTypes}&propertyAmenities=${this.hotel.propertyAmenities}`
        }
        else
          window.location.href=`hotels?destination=${this.hotel.destination}&checkInDate=${this.reformatDate(this.selectedDates[0])}&checkOutDate=${this.reformatDate(this.selectedDates[1])}&adults=${this.adultQuantity}&rooms=${this.roomQuantity}&latitude=${this.latitude}&longitude=${this.longitude}&propertyClasses=${this.hotel.propertyClasses}&propertyTypes=${this.hotel.propertyTypes}&propertyAmenities=${this.hotel.propertyAmenities}`
      } 
      else {
        this.validateField(this.destination, this.errorblocks[0])
        this.validateField(this.hotel.checkInDate, this.errorblocks[1])
        this.validateField(this.hotel.checkOutDate, this.errorblocks[2])
        e.preventDefault
      }
    },
  },
}
</script>
